module.exports = __webpack_public_path__ + "prod/1.42.2/img/hongxing-icon.0355ae76.png";